import { type OpzlyExperimentName } from '../config';
import { type CachedExperiments } from '../types';

/**
 * Compare experiment names with experiments we have in the preview cache.
 * Exclude any experiments if they have previously been marked as bucketed in the cache.
 */
export function filterUnbucketedExperiments(
  experimentNames: OpzlyExperimentName[],
  cachedExps: CachedExperiments | undefined
): OpzlyExperimentName[] {
  return experimentNames.filter((expName) => {
    return cachedExps?.[expName] && cachedExps[expName].bucketed === false;
  });
}
